import { z } from "zod";

export const createMembershipSkuSchema = z.object({
  tenant: z.string().min(1, "Tenant is required").max(255),
  skuPattern: z.string().min(1, "SKU pattern is required").max(255),
  membershipDuration: z.enum(["annual", "monthly"], {
    required_error: "Membership duration is required",
  }),
  description: z.string().max(1000).optional().nullable(),
});

export const updateMembershipSkuSchema = z.object({
  skuPattern: z.string().min(1).max(255).optional(),
  membershipDuration: z.enum(["annual", "monthly"]).optional(),
  description: z.string().max(1000).optional().nullable(),
  isActive: z.boolean().optional(),
});

export type CreateMembershipSkuFormData = z.infer<
  typeof createMembershipSkuSchema
>;
export type UpdateMembershipSkuFormData = z.infer<
  typeof updateMembershipSkuSchema
>;

export interface MembershipSku {
  uuid: string;
  tenant: string;
  skuPattern: string;
  membershipDuration: "annual" | "monthly";
  description: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}
